import type { Translate } from '@/utils/hooks/translation/useTranslation';

export type LanguageAuthorizedType =
    | 'en'
    | 'ru'
    | 'de'
    | 'es'
    | 'fr'
    | 'ja'
    | 'pt'
    | 'it'
    | 'ar'
    | 'zh';

export function languageSubmenu(
    t: Translate,
    callback: (param: LanguageAuthorizedType) => Promise<void>
) {
    return [
        {
            label: t('ai_caption:languages.english'),
            callback: () => callback('en')
        },
        {
            label: t('ai_caption:languages.russian'),
            callback: () => callback('ru')
        },
        {
            label: t('ai_caption:languages.german'),
            callback: () => callback('de')
        },
        {
            label: t('ai_caption:languages.spanish'),
            callback: () => callback('es')
        },
        {
            label: t('ai_caption:languages.french'),
            callback: () => callback('fr')
        },
        {
            label: t('ai_caption:languages.japanese'),
            callback: () => callback('ja')
        },
        {
            label: t('ai_caption:languages.portuguese'),
            callback: () => callback('pt')
        },
        {
            label: t('ai_caption:languages.italian'),
            callback: () => callback('it')
        },
        {
            label: t('ai_caption:languages.arabic'),
            callback: () => callback('ar')
        },
        {
            label: t('ai_caption:languages.chinese'),
            callback: () => callback('zh')
        }
    ];
}

export function captionAiLanguageSubmenu(
    t: Translate,
    callback: (param: LanguageAuthorizedType) => Promise<void>
) {
    return [
        {
            label: t('caption:ai_caption.languages.english'),
            callback: () => callback('en')
        },
        {
            label: t('caption:ai_caption.languages.russian'),
            callback: () => callback('ru')
        },
        {
            label: t('caption:ai_caption.languages.german'),
            callback: () => callback('de')
        },
        {
            label: t('caption:ai_caption.languages.spanish'),
            callback: () => callback('es')
        },
        {
            label: t('caption:ai_caption.languages.french'),
            callback: () => callback('fr')
        },
        {
            label: t('caption:ai_caption.languages.japanese'),
            callback: () => callback('ja')
        },
        {
            label: t('caption:ai_caption.languages.portuguese'),
            callback: () => callback('pt')
        },
        {
            label: t('caption:ai_caption.languages.italian'),
            callback: () => callback('it')
        },
        {
            label: t('caption:ai_caption.languages.arabic'),
            callback: () => callback('ar')
        },
        {
            label: t('caption:ai_caption.languages.chinese'),
            callback: () => callback('zh')
        }
    ];
}
